import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessCotizadorFactoring } from '../utils/gestionCampanaAccess'

const RequireCotizadorFactoringAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessCotizadorFactoring(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireCotizadorFactoringAccess
